import Skeleton from '@material-ui/lab/Skeleton/Skeleton';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import { Tooltip } from '@swf/poker';

import {
  TXTCLI_Private,
  TXTWCL_Anyone_can_find_this_club,
  TXTWCL_Can_only_be_found_through_an_i_ELL,
  TXTWCL_Public
} from './ClubTypeIcon.messages.json';
import styles from './ClubTypeIcon.scss';
import IconOpen from './assets/open.svg';
import IconPrivate from './assets/private.svg';

export interface ClubTypeIconProps {
  isOpenClub: boolean | undefined;
  loading: boolean;
}

const ClubTypeIcon: React.FC<ClubTypeIconProps> = ({ isOpenClub, loading }) => {
  if (isOpenClub === undefined && loading) {
    return (
      <div className={styles.loader}>
        <Skeleton variant="circle" />
      </div>
    );
  }

  if (isOpenClub === undefined) {
    return null;
  }

  const openClubTooltipContent = (
    <>
      <Translation {...TXTWCL_Public} />
      <span>: </span>
      <span className={styles.tooltipClubDescription}>
        <Translation {...TXTWCL_Anyone_can_find_this_club} />
      </span>
    </>
  );

  const privateClubTooltipContent = (
    <>
      <Translation {...TXTCLI_Private} />
      <span>: </span>
      <span className={styles.tooltipClubDescription}>
        <Translation {...TXTWCL_Can_only_be_found_through_an_i_ELL} />
      </span>
    </>
  );

  return (
    <Tooltip
      arrowClassName={styles.tooltipArrow}
      tooltipClassName={styles.tooltip}
      content={isOpenClub ? openClubTooltipContent : privateClubTooltipContent}
      placement="top"
      refElementClassName={styles.tooltipWrapper}
    >
      {isOpenClub ? <IconOpen className={styles.icon} /> : <IconPrivate className={styles.icon} />}
    </Tooltip>
  );
};

export default ClubTypeIcon;
